// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__2zPJb","spanCircle":"styles_spanCircle__rCfbG"};